import * as ACTION from '@Bootstraps/bootstrapActions';
import * as IMG from '@Utils/Images';
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import clsx from 'classnames';

export default function Component() {
  const [clothes, setClothes] = useState([]);
  const { clothesInquiryResponse } = useSelector(state => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(ACTION.clothesInquiry());
  }, [dispatch]);

  useEffect(() => {
    if (clothesInquiryResponse) {
      setClothes(
        clothesInquiryResponse.data.sort(() => Math.random() - 0.5).slice(0, 5)
      );
    }
  }, [clothesInquiryResponse]);

  return (
    <section className="products-section">
      <div className="container">
        <div className="text-center">
          <div className="subtitle">Best Products</div>
          <h1 className="title fw-bold lh-sm mb-5">
            This week's <span className="text-primary2">newest</span> and <br />
            <span className="text-primary2">best selling</span> products
          </h1>
        </div>
        <div className="row justify-content-between m-0 placeholder-glow">
          <div className="col-lg-8 col-md-6 mb-md-0 mb-4">
            <div
              className="product position-relative primary d-flex flex-column justify-content-end"
              style={{
                backgroundImage: `url(${clothes[0]?.thumbnail || IMG.EMPTY})`,
              }}
            >
              <small
                className={clsx(
                  'category fw-semibold position-absolute py-1 px-3',
                  {
                    'placeholder text-dark': !clothes[0]?.category,
                  }
                )}
              >
                {clothes[0]?.category || 'UNKNOWN'}
              </small>
              <div className="product-content d-flex justify-content-between align-items-center py-25 px-4">
                <p className={clsx('fw-semibold text-white normal m-0', {
                  'placeholder text-dark rounded': !clothes[0]?.price
                })}>
                  Rp. {clothes[0]?.price
                      ? `${clothes[0]?.price.toLocaleString('id-ID')},00`
                      : `999.999,00`}
                </p>
                <button
                  onClick={() =>
                    navigate(clothes[0] ? `/clothes/${clothes[0]?.slug}` : ``)
                  }
                  className="btn btn-dark fw-semibold normal px-md-4 px-3 rounded-0"
                  disabled={clothes[0] ? false : true}
                >
                  BUY NOW
                  <span className="text-primary2 ms-2">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="row m-0">
              <div className="col-12 p-0 pb-2">
                <div
                  className="product position-relative d-flex flex-column justify-content-end"
                  style={{
                    backgroundImage: `url(${
                      clothes[1]?.thumbnail || IMG.EMPTY
                    })`,
                  }}
                >
                  <small
                    className={clsx(
                      'category fw-semibold position-absolute py-1 px-3',
                      {
                        'placeholder text-dark': !clothes[1]?.category,
                      }
                    )}
                  >
                    {clothes[1]?.category || 'UNKNOWN'}
                  </small>
                  <div className="product-content d-flex justify-content-between align-items-center py-25 px-4">
                    <p className={clsx('fw-semibold text-white normal m-0', {
                      'placeholder text-dark rounded': !clothes[1]?.price
                    })}>
                      Rp. {clothes[1]?.price
                          ? `${clothes[1]?.price.toLocaleString('id-ID')},00`
                          : `999.999,00`}
                    </p>
                    <button
                      onClick={() =>
                        navigate(
                          clothes[1] ? `/clothes/${clothes[1]?.slug}` : ``
                        )
                      }
                      className="btn btn-dark fw-semibold normal px-md-4 px-3 rounded-0"
                      disabled={clothes[1] ? false : true}
                    >
                      BUY NOW
                      <span className="text-primary2 ms-2">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-12 p-0 pt-3">
                <div
                  className="product position-relative d-flex flex-column justify-content-end"
                  style={{
                    backgroundImage: `url(${
                      clothes[2]?.thumbnail || IMG.EMPTY
                    })`,
                  }}
                >
                  <small
                    className={clsx(
                      'category fw-semibold position-absolute py-1 px-3',
                      {
                        'placeholder text-dark': !clothes[2]?.category,
                      }
                    )}
                  >
                    {clothes[2]?.category || 'UNKNOWN'}
                  </small>
                  <div className="product-content d-flex justify-content-between align-items-center py-25 px-4">
                    <p className={clsx('fw-semibold text-white normal m-0', {
                      'placeholder text-dark rounded': !clothes[2]?.price
                    })}>
                      Rp. {clothes[2]?.price
                          ? `${clothes[2]?.price.toLocaleString('id-ID')},00`
                          : `999.999,00`}
                    </p>
                    <button
                      onClick={() =>
                        navigate(
                          clothes[2] ? `/clothes/${clothes[2]?.slug}` : ``
                        )
                      }
                      className="btn btn-dark fw-semibold normal px-md-4 px-3 rounded-0"
                      disabled={clothes[2] ? false : true}
                    >
                      BUY NOW
                      <span className="text-primary2 ms-2">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-md-5 pt-4">
            <div
              className="product position-relative d-flex flex-column justify-content-end"
              style={{
                backgroundImage: `url(${clothes[3]?.thumbnail || IMG.EMPTY})`,
              }}
            >
              <small
                className={clsx(
                  'category fw-semibold position-absolute py-1 px-3',
                  {
                    'placeholder text-dark': !clothes[3]?.category,
                  }
                )}
              >
                {clothes[3]?.category || 'UNKNOWN'}
              </small>
              <div className="product-content d-flex justify-content-between align-items-center py-25 px-4">
                <p className={clsx('fw-semibold text-white normal m-0', {
                  'placeholder text-dark rounded': !clothes[3]?.price
                })}>
                  Rp. {clothes[3]?.price
                      ? `${clothes[3]?.price.toLocaleString('id-ID')},00`
                      : `999.999,00`}
                </p>
                <button
                  onClick={() =>
                    navigate(clothes[3] ? `/clothes/${clothes[3]?.slug}` : ``)
                  }
                  className="btn btn-dark fw-semibold normal px-md-4 px-3 rounded-0"
                  disabled={clothes[3] ? false : true}
                >
                  BUY NOW
                  <span className="text-primary2 ms-2">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-7 pt-4">
            <div
              className="product position-relative d-flex flex-column justify-content-end"
              style={{
                backgroundImage: `url(${clothes[4]?.thumbnail || IMG.EMPTY})`,
              }}
            >
              <small
                className={clsx(
                  'category fw-semibold position-absolute py-1 px-3',
                  {
                    'placeholder text-dark': !clothes[4]?.category,
                  }
                )}
              >
                {clothes[4]?.category || 'UNKNOWN'}
              </small>
              <div className="product-content d-flex justify-content-between align-items-center py-25 px-4">
                <p className={clsx('fw-semibold text-white normal m-0', {
                  'placeholder text-dark rounded': !clothes[4]?.price
                })}>
                  Rp. {clothes[4]?.price
                      ? `${clothes[4]?.price.toLocaleString('id-ID')},00`
                      : `999.999,00`}
                </p>
                <button
                  onClick={() =>
                    navigate(clothes[4] ? `/clothes/${clothes[4]?.slug}` : ``)
                  }
                  className="btn btn-dark fw-semibold normal px-md-4 px-3 rounded-0"
                  disabled={clothes[4] ? false : true}
                >
                  BUY NOW
                  <span className="text-primary2 ms-2">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};